import React from 'react';
import PropTypes from 'prop-types';
import { H3, UnorderedList, ListItem, Text } from 'components/core/Typography';
import { Check, Plus } from 'components/svg';

import { withStateHandlers } from 'recompose';
import classNames from 'classnames';
import './BenefitsAccordion.scss';

export const enhance = withStateHandlers(
	({ accordionOpen = false }) => ({
		accordionOpen
	}),
	{
		toggleAccordion: ({ accordionOpen }) => () => ({
			accordionOpen: !accordionOpen
		})
	}
);

export const BenefitsAccordion = ({ title, items, accordionOpen, toggleAccordion, className }) => (
	<div className={classNames('benefits-accordion', className)}>
		<H3 size="tiny" weight="bold" color="blue" last>
			{title}
			<span />
		</H3>
		<UnorderedList className={classNames({ expanded: accordionOpen, collapsed: !accordionOpen })}>
			{items.map((item) => (
				<ListItem weight="standard" key={item} color="darkGray">
					<Check />
					<span>
						{item}
					</span>
				</ListItem>
			))}
		</UnorderedList>

		<button onClick={() => toggleAccordion()} type="button">
			<Plus />
			<Text weight="bold" color="priceBlue" last>
				Show All Benefits of SelfStorage.com
			</Text>
		</button>
	</div>
);

BenefitsAccordion.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string.isRequired,
	accordionOpen: PropTypes.bool,
	toggleAccordion: PropTypes.func,
	items: PropTypes.arrayOf(
		PropTypes.string
	).isRequired
};


export default enhance(BenefitsAccordion);
